import gql from 'graphql-tag';

export default gql`
	fragment Member on Member {
		ID
		Email
		Surname
		FirstName
		MiddleName
		Phone
	}
`;

export const UserFragment = gql`
    fragment UserFragment on Member {
        ID
        AllPermissions
        Deactivated
        Email
        FirstName
        JpRegistrationNo
        LegacyKey
        MiddleName
        Phone
        Surname
        MyLastOfficeID
        Groups {
            ID
            Title
            Code
            ParentID
        }
    }
`;
